"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getView = exports.getTypography = exports.getSize = exports.getShapeIconSize = exports.getShape = exports.getPadding = exports.getIconOffset = exports.getCursor = exports.getBorderRadius = void 0;

var _styledComponents = require("styled-components");

var _theme = require("../../theme");

var _Button = require("./Button.templates");

const getView = view => props => (0, _Button.makeTemplates)(props)[view];

exports.getView = getView;

const getSize = size => _Button.sizeList[size];

exports.getSize = getSize;

const getPadding = size => _Button.paddingList[size];

exports.getPadding = getPadding;

const getTypography = size => {
  switch (size) {
    case 'extra-small':
      return _theme.Typography.labelSmall;

    case 'small':
      return _theme.Typography.labelMedium;

    default:
      return _theme.Typography.labelLarge;
  }
};

exports.getTypography = getTypography;

const getIconOffset = size => _Button.iconOffsetList[size];

exports.getIconOffset = getIconOffset;

const getBorderRadius = shape => {
  switch (shape) {
    case 'circle':
      return '50%';

    default:
      return _theme.borderRadius;
  }
};

exports.getBorderRadius = getBorderRadius;

const getShape = (shape, size) => {
  switch (shape) {
    case 'circle':
    case 'square':
      return (0, _styledComponents.css)(["width:", ";padding:0;"], getSize(size));

    default:
      return null;
  }
};

exports.getShape = getShape;

const getShapeIconSize = shape => {
  switch (shape) {
    case 'circle':
    case 'square':
      return (0, _styledComponents.css)(["max-width:100%;max-height:100%;"]);

    default:
      return null;
  }
};

exports.getShapeIconSize = getShapeIconSize;

const getCursor = props => {
  if (props.isDisabled) {
    return 'not-allowed';
  }

  if (props.isSuccess) {
    return 'default';
  }

  if (props.isLoading) {
    return 'wait';
  }

  return null;
};

exports.getCursor = getCursor;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXRWaWV3IiwidmlldyIsInByb3BzIiwibWFrZVRlbXBsYXRlcyIsImdldFNpemUiLCJzaXplIiwic2l6ZUxpc3QiLCJnZXRQYWRkaW5nIiwicGFkZGluZ0xpc3QiLCJnZXRUeXBvZ3JhcGh5IiwiVHlwb2dyYXBoeSIsImxhYmVsU21hbGwiLCJsYWJlbE1lZGl1bSIsImxhYmVsTGFyZ2UiLCJnZXRJY29uT2Zmc2V0IiwiaWNvbk9mZnNldExpc3QiLCJnZXRCb3JkZXJSYWRpdXMiLCJzaGFwZSIsImJvcmRlclJhZGl1cyIsImdldFNoYXBlIiwiY3NzIiwiZ2V0U2hhcGVJY29uU2l6ZSIsImdldEN1cnNvciIsImlzRGlzYWJsZWQiLCJpc1N1Y2Nlc3MiLCJpc0xvYWRpbmciXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9CdXR0b24vQnV0dG9uLnV0aWxzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ3N0eWxlZC1jb21wb25lbnRzJ1xuaW1wb3J0IHsgYm9yZGVyUmFkaXVzLCBUaGVtZWRDb21wb25lbnRQcm9wcywgVHlwb2dyYXBoeSB9IGZyb20gJ350aGVtZSdcbmltcG9ydCB7IGljb25PZmZzZXRMaXN0LCBtYWtlVGVtcGxhdGVzLCBwYWRkaW5nTGlzdCwgc2l6ZUxpc3QgfSBmcm9tICcuL0J1dHRvbi50ZW1wbGF0ZXMnXG5pbXBvcnQgeyBTaGFwZVR5cGUsIFNpemVUeXBlLCBTdHlsZWRCdXR0b25Qcm9wcywgVmlld1R5cGUgfSBmcm9tICcuL0J1dHRvbi50eXBlcydcblxuZXhwb3J0IGNvbnN0IGdldFZpZXcgPSAodmlldzogVmlld1R5cGUpID0+IChwcm9wczogVGhlbWVkQ29tcG9uZW50UHJvcHMpID0+IG1ha2VUZW1wbGF0ZXMocHJvcHMpW3ZpZXddXG5cbmV4cG9ydCBjb25zdCBnZXRTaXplID0gKHNpemU6IFNpemVUeXBlKSA9PiBzaXplTGlzdFtzaXplXVxuXG5leHBvcnQgY29uc3QgZ2V0UGFkZGluZyA9IChzaXplOiBTaXplVHlwZSkgPT4gcGFkZGluZ0xpc3Rbc2l6ZV1cblxuZXhwb3J0IGNvbnN0IGdldFR5cG9ncmFwaHkgPSAoc2l6ZTogU2l6ZVR5cGUpID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnZXh0cmEtc21hbGwnOlxuICAgICAgcmV0dXJuIFR5cG9ncmFwaHkubGFiZWxTbWFsbFxuICAgIGNhc2UgJ3NtYWxsJzpcbiAgICAgIHJldHVybiBUeXBvZ3JhcGh5LmxhYmVsTWVkaXVtXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBUeXBvZ3JhcGh5LmxhYmVsTGFyZ2VcbiAgfVxufVxuXG5leHBvcnQgY29uc3QgZ2V0SWNvbk9mZnNldCA9IChzaXplOiBTaXplVHlwZSkgPT4gaWNvbk9mZnNldExpc3Rbc2l6ZV1cblxuZXhwb3J0IGNvbnN0IGdldEJvcmRlclJhZGl1cyA9IChzaGFwZTogU2hhcGVUeXBlKSA9PiB7XG4gIHN3aXRjaCAoc2hhcGUpIHtcbiAgICBjYXNlICdjaXJjbGUnOlxuICAgICAgcmV0dXJuICc1MCUnXG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGJvcmRlclJhZGl1c1xuICB9XG59XG5cbmV4cG9ydCBjb25zdCBnZXRTaGFwZSA9IChzaGFwZTogU2hhcGVUeXBlLCBzaXplOiBTaXplVHlwZSkgPT4ge1xuICBzd2l0Y2ggKHNoYXBlKSB7XG4gICAgY2FzZSAnY2lyY2xlJzpcbiAgICBjYXNlICdzcXVhcmUnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgd2lkdGg6ICR7Z2V0U2l6ZShzaXplKX07XG4gICAgICAgIHBhZGRpbmc6IDA7XG4gICAgICBgXG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIG51bGxcbiAgfVxufVxuXG5leHBvcnQgY29uc3QgZ2V0U2hhcGVJY29uU2l6ZSA9IChzaGFwZTogU2hhcGVUeXBlKSA9PiB7XG4gIHN3aXRjaCAoc2hhcGUpIHtcbiAgICBjYXNlICdjaXJjbGUnOlxuICAgIGNhc2UgJ3NxdWFyZSc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXgtd2lkdGg6IDEwMCU7XG4gICAgICAgIG1heC1oZWlnaHQ6IDEwMCU7XG4gICAgICBgXG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIG51bGxcbiAgfVxufVxuXG5leHBvcnQgY29uc3QgZ2V0Q3Vyc29yID0gKHByb3BzOiBTdHlsZWRCdXR0b25Qcm9wcykgPT4ge1xuICBpZiAocHJvcHMuaXNEaXNhYmxlZCkge1xuICAgIHJldHVybiAnbm90LWFsbG93ZWQnXG4gIH1cblxuICBpZiAocHJvcHMuaXNTdWNjZXNzKSB7XG4gICAgcmV0dXJuICdkZWZhdWx0J1xuICB9XG5cbiAgaWYgKHByb3BzLmlzTG9hZGluZykge1xuICAgIHJldHVybiAnd2FpdCdcbiAgfVxuXG4gIHJldHVybiBudWxsXG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFHTyxNQUFNQSxPQUFPLEdBQUlDLElBQUQsSUFBcUJDLEtBQUQsSUFBaUMsSUFBQUMscUJBQUEsRUFBY0QsS0FBZCxFQUFxQkQsSUFBckIsQ0FBckU7Ozs7QUFFQSxNQUFNRyxPQUFPLEdBQUlDLElBQUQsSUFBb0JDLGdCQUFBLENBQVNELElBQVQsQ0FBcEM7Ozs7QUFFQSxNQUFNRSxVQUFVLEdBQUlGLElBQUQsSUFBb0JHLG1CQUFBLENBQVlILElBQVosQ0FBdkM7Ozs7QUFFQSxNQUFNSSxhQUFhLEdBQUlKLElBQUQsSUFBb0I7RUFDL0MsUUFBUUEsSUFBUjtJQUNFLEtBQUssYUFBTDtNQUNFLE9BQU9LLGlCQUFBLENBQVdDLFVBQWxCOztJQUNGLEtBQUssT0FBTDtNQUNFLE9BQU9ELGlCQUFBLENBQVdFLFdBQWxCOztJQUNGO01BQ0UsT0FBT0YsaUJBQUEsQ0FBV0csVUFBbEI7RUFOSjtBQVFELENBVE07Ozs7QUFXQSxNQUFNQyxhQUFhLEdBQUlULElBQUQsSUFBb0JVLHNCQUFBLENBQWVWLElBQWYsQ0FBMUM7Ozs7QUFFQSxNQUFNVyxlQUFlLEdBQUlDLEtBQUQsSUFBc0I7RUFDbkQsUUFBUUEsS0FBUjtJQUNFLEtBQUssUUFBTDtNQUNFLE9BQU8sS0FBUDs7SUFFRjtNQUNFLE9BQU9DLG1CQUFQO0VBTEo7QUFPRCxDQVJNOzs7O0FBVUEsTUFBTUMsUUFBUSxHQUFHLENBQUNGLEtBQUQsRUFBbUJaLElBQW5CLEtBQXNDO0VBQzVELFFBQVFZLEtBQVI7SUFDRSxLQUFLLFFBQUw7SUFDQSxLQUFLLFFBQUw7TUFDRSxXQUFPRyxxQkFBUCw2QkFDV2hCLE9BQU8sQ0FBQ0MsSUFBRCxDQURsQjs7SUFLRjtNQUNFLE9BQU8sSUFBUDtFQVRKO0FBV0QsQ0FaTTs7OztBQWNBLE1BQU1nQixnQkFBZ0IsR0FBSUosS0FBRCxJQUFzQjtFQUNwRCxRQUFRQSxLQUFSO0lBQ0UsS0FBSyxRQUFMO0lBQ0EsS0FBSyxRQUFMO01BQ0UsV0FBT0cscUJBQVA7O0lBS0Y7TUFDRSxPQUFPLElBQVA7RUFUSjtBQVdELENBWk07Ozs7QUFjQSxNQUFNRSxTQUFTLEdBQUlwQixLQUFELElBQThCO0VBQ3JELElBQUlBLEtBQUssQ0FBQ3FCLFVBQVYsRUFBc0I7SUFDcEIsT0FBTyxhQUFQO0VBQ0Q7O0VBRUQsSUFBSXJCLEtBQUssQ0FBQ3NCLFNBQVYsRUFBcUI7SUFDbkIsT0FBTyxTQUFQO0VBQ0Q7O0VBRUQsSUFBSXRCLEtBQUssQ0FBQ3VCLFNBQVYsRUFBcUI7SUFDbkIsT0FBTyxNQUFQO0VBQ0Q7O0VBRUQsT0FBTyxJQUFQO0FBQ0QsQ0FkTSJ9